import { Description, getHashTags } from "components/elements/description/Description";
import { LoadingSpinner } from "components/loading-spinner/LoadingSpinner";
import { useEffect, useState } from "react";
import { sandboxApi } from "services/sandbox-api/api";
import { Button, Dialog, Label, LabeledInput, Tag, TagContainer } from "@itwin/itwinui-react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import styles from "./ReadonlySettingsDialog.module.css";
import { routeTo } from "router";
import { Link } from "react-router-dom";

interface SandboxSettingsActionHandlerProps {
  sandboxId?: string;
  userId?: string;
  onClose?: () => void;
}

export const ReadonlySettingsDialog = ({ sandboxId: codeshareId, userId, onClose }: SandboxSettingsActionHandlerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = sandboxApi.useCodeShareQuery(userId && codeshareId ? { userId, codeshareId } : skipToken);

  const onConfirm = () => {
    setIsModalOpen(false);
    onClose && setTimeout(onClose, 200);
  }

  const onCancel = () => {
    setIsModalOpen(false);
    onClose && setTimeout(onClose, 200);
  };

  useEffect(() => {
    setTimeout(() => {
      setIsModalOpen(true)
    }, 5);
  }, []);

  return (
    <Dialog isOpen={isModalOpen} onClose={onCancel} closeOnEsc closeOnExternalClick preventDocumentScroll trapFocus setFocus isDismissible>
      <Dialog.Backdrop />
      <Dialog.Main className={styles.dialog}>
        <Dialog.TitleBar titleText="Sandbox Settings" />
        <Dialog.Content className={styles.layout}>
          {!data || isLoading
            ? <LoadingSpinner centered message="Loading Settings..." />
            : <>
              <LabeledInput label="Name" readOnly id="sandbox-name" value={data.name} />
              <div>
                <Label htmlFor="sandbox-description">Description</Label>
                <Description id="sandbox-description" description={data.description} className={styles.description} openLinkNewTab={true} />
              </div>
              <TagContainer overflow="scroll">
                {getHashTags(data.description).map((tag) => <Tag key={tag}><Link className="iui-anchor" to={routeTo.search(tag)} target="_blank" rel="noopener noreferrer">{tag.slice(1)}</Link></Tag>)}
              </TagContainer>
            </>}
        </Dialog.Content>
        <Dialog.ButtonBar>
          <Button styleType="high-visibility" onClick={onConfirm}>Close</Button>
        </Dialog.ButtonBar>
      </Dialog.Main>
    </Dialog>
  )
};
